var _style, _path, _defs, _path2, _ellipse, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgChickpeaPasta(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 212.6 212.6",
    style: {
      enableBackground: "new 0 0 212.6 212.6"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill:#B92555;}\n\t.st1{clip-path:url(#SVGID_2_);fill:#FDCB7C;}\n\t.st2{fill:#FFEBC4;}\n\t.st3{fill:#FDC95F;}\n\t.st4{fill:#F7A93C;}\n\t.st5{fill:none;stroke:#F6A200;stroke-width:1.553;stroke-linecap:round;stroke-miterlimit:10;}\n")), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M106.63,182.83c42.69,0,77.3-34.29,77.3-76.6c0-42.3-34.61-76.6-77.3-76.6s-77.3,34.29-77.3,76.6 C29.33,148.54,63.94,182.83,106.63,182.83"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    id: "SVGID_1_",
    d: "M105.74,134.3c-2.47-6.78-8.95-13.98-17.06-14.64c-0.09-0.01-0.19-0.01-0.28-0.01 c-0.69-1.48-2.27-2.51-4.11-2.51c-2.45,0-4.43,1.83-4.48,4.1c-0.2,0.09-0.31,0.14-0.31,0.14c-0.48,0.24-2.2,1.13-4.24,3.03 c-1.22,1.14-5.71,5.33-7.07,12.21c-1.37,7,0.7,15.72,5.55,18.47c2.51,1.42,5.15,1.51,5.15,1.51c1.91,0.07,3.49-0.41,4.44-0.71 c2.31-0.7,3.15-1.52,5.55-1.82c0.85-0.11,1.54-0.1,1.92-0.1c2.12,0.01,3.4,0.44,4.34,0.61c3.46,0.62,6.64-1.41,6.96-1.62 c2.66-1.74,3.55-4.49,4.14-6.06C108.33,141.39,106.49,136.37,105.74,134.3z"
  }))), /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_1_",
    style: {
      overflow: "visible",
      fill: "#FED998"
    }
  }), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_2_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_1_",
    style: {
      overflow: "visible"
    }
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M75.68,120.56c2.71,0.35,7.16,1.32,11.65,4.35c1.99,1.34,5.37,3.68,7.72,8.18c0.82,1.56,2.98,5.84,2.19,11.32 c-0.54,3.73-2.19,6.28-2.62,6.93c-1.34,1.99-2.86,3.29-3.91,4.05c2.19,0.36,4.38,0.71,6.57,1.07c1.35-0.18,6.97-1.06,10.6-5.89 c3.59-4.78,2.84-10.25,2.47-12.99c-1.11-8.1-6.39-13.14-10.32-16.88c-3.71-3.54-8.28-7.88-14.43-7.74 c-1.38,0.03-5.09,0.12-7.68,2.92C76.36,117.56,75.86,119.49,75.68,120.56z"
  }))), _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    transform: "matrix(0.9917 -0.1289 0.1289 0.9917 -17.45 11.2863)",
    className: "st2",
    cx: 78.43,
    cy: 140.4,
    rx: 3.03,
    ry: 10.19
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M100.76,54.05c0,0,0.08-6.23,2.5-6.14s10.56,8.83,12.6,19.02c0.8,4,1.52,8.05,1.51,12.14 c0,3.35-0.96,6.95,1.83,9.51c2.35,2.15,5.78,0.47,8.52-1.37c2.75-1.84,5-5.18,15.89-4.46c10.89,0.72,15.07,0.94,16.64,3.05 c1.57,2.11-1.65,4.12-2.95,5.03s-5.55,1.23-2.93,3.17c2.62,1.93,5.67,3.54,5.18,5.29s-3.31,1.78-5.1,2.64 c-1.79,0.86-3.04,1.27-1.27,3.43c1.77,2.16,4.36,3.65,3.22,5.67s-4.26,1.26-6.63,1.26c-2.37,0-2.15,2.06-1.09,3.9 c1.06,1.84,2.78,3.62,1.79,5.03c-0.99,1.41-4.01,0.53-5.82,0.3c-1.81-0.23-2.81-0.25-2.63,1.95c0.18,2.2,1.41,4.51,0.34,5.69 c-1.08,1.17-3.24-0.29-5.36-1.02c-2.12-0.73-3.69-2.26-4.26,1.55c-0.57,3.81-0.18,6.35-1.52,6.24s-5.32-3.52-6.15-4.23 s-1.56,0.2-1.61,1.91s0.67,4.04-2.17,5.36c-2.84,1.32-4.79-0.09-7.66-7.47c-1.78-4.58-3.49-9.31-3.92-14.24 c-0.22-2.51-0.03-4.96,0.67-7.38c0.61-2.11,1.97-4.49,1.83-6.74c-0.13-2.12-4.24-4.99-7.8-1.61c-3.55,3.37-5.7,6.3-14.07,7.63 s-16.26,0.99-18.45-0.33c-2.19-1.32-2.96-5.25,0.87-7.12s5.27-2.16,2.45-4.14c-2.82-1.98-7.25-4.14-3.72-5.36 c3.53-1.22,6.11-2.68,4.82-4.43c-1.3-1.75-5.95-4.76-4.91-6.37s4.57,0.11,6.87-1.06c2.3-1.16,0.97-2.78-0.26-4.81 c-1.23-2.02-3.97-4.92-0.26-4.81c3.71,0.11,7.56,0.84,6.76-2.38s-3.48-7.53,0.5-6.77s7.36,2.8,7.28,0.19s-1.99-9.54,1.34-7.86 s6.44,3.94,6.92,2.84C101.03,55.63,100.76,54.05,100.76,54.05z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M108.52,88.85c0,0-8.04-7.71-10.97-11.01c-2.93-3.3-7.07-2.23-9.33,1.75s-2.65,6.75,3.61,8.78 c6.26,2.03,11.77,4.45,14.31,3.78C108.67,91.47,108.52,88.85,108.52,88.85z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M141.63,106.84c0,0-8.12-2.05-13.06-4.77c-4.94-2.71-6.2-3.45-6.85-1.96c-0.65,1.49-0.38,1.56,2.65,7.4 c3.03,5.84,4.33,10.54,5.62,12.29c1.3,1.75,6.37-2.83,7.55-5.05c1.19-2.22,4.98-1.59,6.24-3.79S141.63,106.84,141.63,106.84z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M110.49,90.31c0,0,4.53,1.77,7.88,4.68c2.64,2.28,3.5,2.72,3.5,2.72"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgChickpeaPasta);
export default __webpack_public_path__ + "static/media/Chickpea_pasta.191b0d256be24149a87dc92a1a3da4ea.svg";
export { ForwardRef as ReactComponent };